export default __webpack_public_path__ + "static/media/yeetpay.9c7f2633.png";